import {BookingSessionStorageKeys} from "./booking-session-storage-keys";
import {EmbeddedStorage} from "../../../storage/embedded-storage";

export class BookingEntityStorage<TKey extends string> extends EmbeddedStorage<TKey, BookingSessionStorageKeys>  {


}
